export enum PaymentType {
    CASH = 'CASH',
    BANK_CARD = 'BANK_CARD',
    BANK_TRANSFER = 'BANK_TRANSFER',
    WALLET = 'WALLET',
    PHONE_BALANCE = 'PHONE_BALANCE',
    TERMINAL = 'TERMINAL',
    PROVIDER_CONTROLLED = 'PROVIDER_CONTROLLED'
}
